module.exports = __webpack_public_path__ + "img/hero-xs.3799080.webp";